import * as React from 'react';
import { useTranslation } from 'react-i18next';

import errorPicture from '@/assets/playing.png';
import { PAYMENTS_FRONTEND_URL } from '@/config';

export type ErrorPageProps = {
  customImage?: string;
  actionButton?: string;
};

export const ErrorPage = ({ customImage = errorPicture, actionButton = PAYMENTS_FRONTEND_URL }) => {
  const { t } = useTranslation();

  return (
    <div className="h-screen w-screen flex items-center">
      <div className="w-screen flex flex-col md:flex-row items-center justify-center px-5 text-gray-700">
        <div className="max-w-md">
          <div className="text-5xl font-dark font-bold">{t('ErrorPage.title')}</div>
          <p className="my-8 text-2xl md:text-3xl font-light leading-normal">
            {t('ErrorPage.description')}
          </p>
          <p className="mb-8">{t('ErrorPage.action')}</p>
          <a
            title={t('NotFound.back')}
            href={actionButton}
            className="inline-block rounded cursor-pointer py-4 px-8 bg-md-turquoise hover:bg-md-turquoiseAlt text-white hover:text-white uppercase font-bold"
          >
            {t('ErrorPage.back')}
          </a>
        </div>
        <div className="max-w-lg">
          <img width="400" className="ml-8" alt="Error" src={customImage} />
        </div>
      </div>
    </div>
  );
};
